import { removeEventFromEvar47or97Variable } from '../railsAnalytics';
import { availabilityBucketOmnitureMapping } from './RailsConstant';

export const calculateTtuExtent = (trainsList: any[]) => {
  if (trainsList?.length === 0) {
    return 'ttu_0';
  }
  const ttuPercentage = ceilOffToNearestTens(trainsList);
  return `ttu_${ttuPercentage}`;
};

function ceilOffToNearestTens(trainsList: any[]) {
  const totalTbsCards = trainsList.reduce(
    (total, train) => total + train?.tbsAvailability?.length,
    0,
  );

  const ttuTbsCards = trainsList.reduce(
    (total, train) =>
      total +
      train?.tbsAvailability?.filter((tbsCard: any) => tbsCard?.availablityStatus === null).length,
    0,
  );
  return Math.ceil((ttuTbsCards / totalTbsCards) * 10) * 10; // ceil To Nearest Tens
}

export const removeTtuTrackingEvars = () => {
  Object.keys(availabilityBucketOmnitureMapping).forEach((key: string) => {
    removeEventFromEvar47or97Variable(availabilityBucketOmnitureMapping[key]);
  });
  for (let ttuValue = 0; ttuValue <= 100; ttuValue += 10) {
    removeEventFromEvar47or97Variable(`ttu_${ttuValue}`);
  }
};

export const isDynamicTrainInListing = (trainList: any = []) => {
  try {
    return trainList?.some((train: any) => train?.isDynamicTrain);
  } catch (e) {
    console.error('Error in getting isDynamicTrainInListing', e);
    return false;
  }
};
